equalheight = function(container){
  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
  jQuery(container).each(function() {
    $el = jQuery(this);
    jQuery($el).height('auto');
    topPostion = $el.position().top;
    if (currentRowStart != topPostion) {
      for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}

jQuery(document).ready(function(e) {
	// product detail page expand collapse section
	jQuery('.product-expand-collapse-item .product-expand-collapse-item-title').click(function(e) {
        jQuery(this).toggleClass('open');
		jQuery(this).next().slideToggle();
    });
  
  
  
  	 jQuery('.tag_filter_select select').change(function(e) {
		tagFilterProducts(); 
    });
  
	//tag_filter_hair tag_filter_eyes
	function tagFilterProducts() {
        var $target1 = $('#tag_filter_hair');
        var $target2 = $('#tag_filter_eyes');
        var value1 = $target1.val();
        var value2 = $target2.val();
        var endValue = "";
        var collection = '/collections/' + $target1.data('collection-handle') + '/';
    
    
        // Filter "Hair" if not All
        if(value1){
          endValue = value1;
    
          // And Filter "Eyes" if not All
          if(value2){
            endValue += "," + value2;
          }
        }
        // Or Filter "Eyes" if not All
        else if(value2){
          endValue = value2;
        }
        
        location = collection + endValue;
	}
  
  	// search form validation
  /*
  	jQuery('form.search_form').submit(function(e) {
        var search_value = jQuery.trim(jQuery(this).find('input[type="text"]').val());        
        if(search_value == '' || search_value == 0){
            jQuery(this).find('input[type="text"]').css("border-color","blue");
            e.preventDefault();
          	return false;
          alert(search_value);
        }

        jQuery(this).find('input[type="text"]').blur(
        function(){
            jQuery(this).css({'border-color' : 'inherit'});
        });	
    });
  
  */
  
  /*FAQs*/
  jQuery('.faqAccordion button').click(function(e) {
     jQuery(this).toggleClass('active');
     /*jQuery(this).parent().siblings().children().removeClass('active');*/
  });
  
  
  // fade in #back-top
  jQuery(function () {
    jQuery(window).scroll(function () {
      if (jQuery(this).scrollTop() > 100) {
        jQuery('.back-to-top').fadeIn();
      } else {
        jQuery('.back-to-top').fadeOut();
      }
    });

    // scroll body to 0px on click
    jQuery('.back-to-top').click(function () {
      jQuery('body,html').animate({
        scrollTop: 0
      }, 500);
      return false;
    });
  });
  jQuery(window).resize(function() {
    if(jQuery(window).width()>798){
      var top_minus = 65;
    }else{
      var top_minus = 60;
    }
  });
  jQuery("a.smoothScroll").on('click', function(event) {
    if(jQuery(window).width()>798){
      var top_minus = 65;
    }else{
      var top_minus = 60;
    }
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      jQuery('html, body').animate({
        scrollTop: jQuery(hash).offset().top - top_minus
      }, 1000, function(){
      });
    }
  });
  
  
  // newsletter popup
  /*
  jQuery('.footer .loop-3 ul li:first-child a').click(function(e) {
    jQuery('#klaviyo-newsletter-popup-btn').click();
	e.preventDefault();
	return (false);
  });
  */
  
  // For Dot Dot JS
  /*
  jQuery(".dotdot").dotdotdot({
    // Options go here
  });
  */
  
  // equal height for product detail page
  //equalheight(jQuery(".product-list .thumbnail"));  
  jQuery(".mob-lang select").val(jQuery("#ly-languages-switcher").val());
  jQuery(".mob-lang select").change(function(){
    var selectedCountry = jQuery(this).children("option:selected").val();
	jQuery("#ly-languages-switcher").val(selectedCountry);
    jQuery("#ly-languages-switcher").change();

  });
  
});


/* Start: Keep Reviews and Meet Fields Displayed on Desktop */
var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;

if(!isMobile) {
  jQuery(window).on('load', function(){
    jQuery('.product-expand-collapse-item .product-expand-collapse-item-title').addClass('open');
    jQuery('.product-expand-collapse-item .product-expand-collapse-item-description').slideToggle();
  });
}
/* End: Keep Reviews and Meet Fields Displayed on Desktop */


/********** title read more **********/
titlereadmore  = function()
{
  jQuery(".product-wrap .product-details .title").readmore({
  	speed: 75, // how fast to animate 
    moreLink: '<a href="#" class="ricon"></a>', // (raw HTML)
    lessLink: '<a href="#" class="ricon less"></a>', // (raw HTML)
  });
}


/*********features equalHeight based on column number 
Remove below commented code for equal height in product title
*******************/
var $ = jQuery;
setHeights  = function()
{
 
  if(jQuery(window).width() > 370) {
    // Address Box H 370
    var $list   = $( '.product-equ' ),
        $addH = $list.find('.title-equ');

    $addH.css( 'height', 'auto' );

    var perRow = Math.floor( $list.width() / $addH.width() );
    console.log('row:'+perRow);
    if(jQuery(window).width() > 1100) {
      if( perRow == null || perRow < 3 ) return true;
    } else {
      if( perRow == null || perRow < 2 ) return true;
    }

    for( var i = 0, j = $addH.length; i < j; i += perRow )
    {
      var maxHeight   = 0,
          $row        = $addH.slice( i, i + perRow );

      $row.each( function()
                {
        var addHheight = parseInt( $( this ).outerHeight() );
        if ( addHheight > maxHeight ) maxHeight = addHheight;
      });
      if(maxHeight>50){maxHeight=50;} 
      $row.css( 'height', maxHeight );
    }
  }else{
    var $list   = $( '.product-equ' ),
        $addH = $list.find('.title-equ');
	
    $('.product-wrap .product-details .title').readmore('destroy');
    $addH.css( 'height', 'auto' );
  }
};

$(function() {
  titlereadmore();
  setHeights();
});

jQuery(window).on('resize', function(e) {
  setTimeout(function(){
  	$(function() { 
      titlereadmore();
      setHeights();      
    });
  },500);
});